import {
  DEV_SHELL_DOCUMENT_THEME_STORAGE_KEY,
  type ShellDocumentTheme,
  resolveInitialShellDocumentTheme,
} from './shellDocumentTheme'

function isTheme(value: string | null): value is ShellDocumentTheme {
  return value === 'dark' || value === 'light'
}

export function readDevShellDocumentThemeFromSession(): ShellDocumentTheme | null {
  try {
    const raw = sessionStorage.getItem(DEV_SHELL_DOCUMENT_THEME_STORAGE_KEY)
    return isTheme(raw) ? raw : null
  } catch {
    return null
  }
}

export function writeDevShellDocumentThemeToSession(theme: ShellDocumentTheme): void {
  try {
    sessionStorage.setItem(DEV_SHELL_DOCUMENT_THEME_STORAGE_KEY, theme)
  } catch {
    return
  }
}

export function initialDevShellDocumentTheme(): ShellDocumentTheme {
  return resolveInitialShellDocumentTheme(globalThis.location.search)
}
